import template from './errorMessage.html';
import controller from './errorMessage.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    error: '<',
  },
};

export default component;
